import { returnsTeamWeightByZoneSchema } from "@redotech/redo-model/rate-table/rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTeamOverrideRateTables = {
  name: "getTeamOverrideRateTables" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ rateTables: z.array(returnsTeamWeightByZoneSchema) }),
};
